import UPInput from 'components/input';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import {
  COMPANY_PAYROLL__MAXIMUM_PLANNED_HOURS,
  COMPANY_PAYROLL__MINIMUM_PERFORMED_HOURS,
} from 'translations/constants';
import { onChangeHourValue } from './helpers';
import { IntervalHourBox, IntervalText } from './styles';
import { WorkhourSettingsFields, WorkhourSettingsProps } from './types';
import WorkScheduleFields from './WorkScheduleFields';

const WorkhourSettings = (props: WorkhourSettingsProps) => {
  const { workhourSettings, setWorkhourSettings, setShouldUpdate, setValidValues } = props;
  const [t] = useTranslation();

  return (
    <>
      <WorkScheduleFields
        workingSystem={workhourSettings?.workingSystem ?? null}
        totalHours={workhourSettings?.totalHours ?? null}
        allowEmptyTotalHours={false}
        onChangeWorkingSystem={workingSystem => {
          setWorkhourSettings(prevState => ({ ...prevState, workingSystem }));
          setValidValues(true);
          setShouldUpdate(true);
        }}
        onChangeTotalHours={(totalHours, isValid) => {
          setWorkhourSettings(prevState => ({ ...prevState, totalHours }));
          setValidValues(isValid);
          setShouldUpdate(true);
        }}
      />
      <IntervalHourBox>
        <IntervalText sx={{ width: '70%' }}>{t(COMPANY_PAYROLL__MINIMUM_PERFORMED_HOURS)}</IntervalText>
        <UPInput
          sx={{ width: '35%' }}
          value={workhourSettings?.minimumWorkhours ?? ''}
          maxLength={6}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            onChangeHourValue(
              event,
              setWorkhourSettings,
              WorkhourSettingsFields.MIN_HOURS,
              setValidValues,
              setShouldUpdate,
            )
          }
          placeholder="0.00"
          // type="number"
          // step={0.01}
          label=""
        />
      </IntervalHourBox>
      <IntervalHourBox>
        <IntervalText sx={{ width: '70%' }}>{t(COMPANY_PAYROLL__MAXIMUM_PLANNED_HOURS)}</IntervalText>
        <UPInput
          sx={{ width: '35%' }}
          value={workhourSettings?.maximumWorkhours ?? ''}
          maxLength={6}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            onChangeHourValue(
              event,
              setWorkhourSettings,
              WorkhourSettingsFields.MAX_HOURS,
              setValidValues,
              setShouldUpdate,
            )
          }
          placeholder="0.00"
          // type="number"
          // step={0.01}
          label=""
        />
      </IntervalHourBox>
    </>
  );
};

export default WorkhourSettings;
